import { inject } from 'vue';

export const useFeature = () => {
    const $feature = inject<any>('$feature');
    return {
        isEnabled: (feature: string, defaultValue: boolean = true) =>
            $feature.isEnabled(feature, defaultValue),
        isEnabledForAccount: (accountId: number, feature: string) =>
            $feature.isEnabledForAccount(accountId, feature),
    };
};
